export const imageSize = (url: string, size: string): string => {
  return url.split('.')[0] + '_' + size + '.' + url.split('.')[1];
};
